var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('PromptTrackAndTrace'),_c('keep-alive',[_c(_vm.layout,{tag:"component"})],1),_c('DialogSelectItem'),_c('DialogSuccess'),_c('footer',[_c('PromptUpdateApp'),_c('PromptCookieConsent')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }